<template>
    <div class="homeIndex" v-loading="loading">
      <patch :data="data" />
    </div>
</template>
<script>
import { getIndex } from '@/api/index.js';
import Patch from '../common/components/patch.vue';
export default {
    components: { Patch },
    name: "HOMEINDEX",
    data() {
        return {
            loading: false,
            data: []
        };
    },
    created() {
      if(!this.$route.query.level) localStorage.setItem('location', '')
      this.getIndex(this.$route.query.languageId || 1);
    },
    methods: {
        async getIndex(val) {
            this.loading = true;
            await getIndex(val).then(res => {
                this.data = res.data;
                this.loading = false;
            });
        },
    },
    watch: {
        $route(val) {
          if(!this.$route.query.level) localStorage.setItem('location', '')
          this.getIndex(this.$route.query.languageId);
        }
    },
}
</script>
<style lang="less" scoped>
.homeIndex{
    overflow: hidden;

}

.el-row, .el-col{
    padding-left: 10px!important;
    padding-right: 10px!important;
}
.clearfix {
    display: block;
    zoom: 1;

    &:after {
        content: " ";
        display: block;
        font-size: 0;
        height: 0;
        clear: both;
        visibility: hidden;
    }
}



@media (min-width: 768px) and (max-width: 992px) { 
  

}
@media (min-width: 992px) and (max-width: 1200px) { 
  

}
@media only screen and (min-width: 1200px){
  
}






</style>


// WEBPACK FOOTER //
// src/components/homeIndex/homeIndex.vue